import React from "react";
import { Output } from "../Text";
import { ItemTeaser, Modal, ContentSection } from "@vwfs-bronson/bronson-react";
import PropTypes from "prop-types";
import { getActualPage, trackInteractionSuccess } from "../pages/page.utils";
import { Analytics } from "../services/analytics";
import { isVtiBOP } from "../common/JourneyType";

class CustomerSupportModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
    };
  }

  trackPage = () => {
    setTimeout(() => {
      const pageData = {
        [Analytics.keys.pageName()]: getActualPage(),
        [Analytics.keys.viewChange()]: "Contact",
      };
      trackInteractionSuccess("Contact layer", pageData);
    }, 1000);
  };

  componentDidUpdate() {
    if (this.state.visible) {
      this.trackPage();
    }
  }

  show() {
    this.setState({ visible: true });
  }

  hide() {
    this.setState({ visible: false });
  }

  emailBody() {
    const originSystem = this.props.prefill?.salesChannel?.originSystem;
    let html = '';
    if (originSystem) {
      html = `${Output.resolve(
        `pages.customerSupport.eMail.bodyHeading`
      )}\n\n`;
  
      if (this.props.prefill?.vehicleData?.model?.description) {
        html +=`${Output.resolve("pages.customerSupport.eMail.vehicle")} ${this.props.prefill.vehicleData.model.description} \n`
      }
      if (this.props.prefill?.vehicleData?.model?.year) {
        html +=`${Output.resolve("pages.customerSupport.eMail.modelYear")} ${this.props.prefill.vehicleData.model.year} \n` 
      }
      if (this.props.prefill?.vehicleData?.vin) {
        html +=`${Output.resolve("pages.customerSupport.eMail.vin")} ${this.props.prefill?.vehicleData?.vin} \n`
      }
      if (this.props.prefill?.transaction?.storefrontTransactionId) {
        html +=`${Output.resolve("pages.customerSupport.eMail.storefrontTransaction")} ${this.props.prefill?.transaction?.storefrontTransactionId} \n`
      }
      if (this.props.prefill?.transaction?.id) {
        html +=`${Output.resolve("pages.customerSupport.eMail.checkoutTransaction")} ${this.props.prefill?.transaction?.id} \n`
      }
      if (this.props.prefill?.salesChannel?.originSystem) {
        html +=`${Output.resolve("pages.customerSupport.eMail.storefront")} ${this.props.prefill?.salesChannel?.originSystem} \n`
      }
    }

    return encodeURIComponent(html);
  }

  render() {
    const { visible } = this.state;
    const { onClose } = this.props;
    const originSystem = this.props.prefill?.salesChannel?.originSystem;
    return (
      <Modal
        title={Output.resolve("pages.customerSupport.title")}
        onClose={() => {
          this.hide();
          if (onClose) {
            onClose();
          }
        }}
        shown={visible}
      >
        <div className="u-pr-small u-pl-small">
          {Output.resolveAsMarkdown("pages.customerSupport.text")}
        </div>

        <ContentSection.ComponentWrapper>
          <ItemTeaser
            icon={"semantic-mail"}
            linkLabel={Output.resolve(
              isVtiBOP(originSystem)
                ? "pages.customerSupport.vti.eMail.label"
                : "pages.customerSupport.eMail.label"
            )}
            linkProps={{
              href: `mailto:${Output.resolve(
                isVtiBOP(originSystem)
                  ? "pages.customerSupport.vti.eMail.address"
                  : "pages.customerSupport.eMail.address"
              )}?subject=${Output.resolve("pages.customerSupport.eMail.subject")}${this.props.prefill?.vehicleData?.model.description}
              &body=${this.emailBody()}`,
              target: "_blank",
              element: "a"
            }}
          ></ItemTeaser>

          <ItemTeaser
            className="u-mt"
            icon={"semantic-phone"}
            linkLabel={Output.resolve(isVtiBOP(originSystem) ? "pages.customerSupport.vti.phone" : "pages.customerSupport.phone.label")}
          ></ItemTeaser>
          
          {!isVtiBOP(originSystem) &&
            Output.resolveAsMarkdown(
              "pages.customerSupport.phone.additionalText"
            )}
        </ContentSection.ComponentWrapper>

        {Output.resolveAsMarkdown("pages.customerSupport.legalDisclaimer")}
      </Modal>
    );
  }
}

CustomerSupportModal.propTypes = {
  onClose: PropTypes.func,
};

export { CustomerSupportModal };
